import React, { useState } from 'react';
import { Box, Typography, Stack, Button, Collapse, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function PhysicianNotes({ notes }) {
    const [open, setOpen] = useState(true);

    if (!notes) return null;

    return (
        <Box sx={{ px: 2, py: 1, backgroundColor: theme => theme.palette.background.default, borderRadius: 2 }}>
            <Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant='heavy'>Physician Notes for Clinical Staff</Typography>
                        <Tooltip title="These notes are provided by the physician for your reference and may not necessarily need to be logged into an EHR.">
                            <IconButton size="small" sx={{ p: 0.5 }}>
                                <InfoOutlinedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    {open ? (
                        <Button size="small" variant="outlined" onClick={() => setOpen(false)}>
                            Acknowledge
                        </Button>
                    ) : (
                        <Button size="small" variant="text" onClick={() => setOpen(true)}>
                            Show Notes
                        </Button>
                    )}
                </Stack>
                <Collapse in={open}>
                    <Box sx={{ backgroundColor: theme => theme.palette.grey[100], borderRadius: 1, p: 1, mt: 1 }}>
                        <Typography variant="normal" color="text.secondary">
                            {notes}
                        </Typography>
                    </Box>
                </Collapse>
            </Stack>
        </Box>
    );
}

export default PhysicianNotes;